/**
 * Commonly used strings
 */

export default {
    // Prepositions
    d_at: 'at',
    d_by: 'by',
    d_created: 'created',
    d_edited: 'edited',
    d_on: 'on',
    d_from: 'from',
    d_to: 'to',
    d_using: 'using',

    // Answers
    d_yes: 'yes',
    d_no: 'no',

    // Pronouns
    d_me: 'me',
    d_your: 'your',

    // Buttons
    d_ok: 'OK',
    d_cancel: 'Cancel',
    d_submit: 'Submit',
    d_done: 'Done',
    d_undo: 'Undo',

    // Product labels
    d_user: 'User',
    d_contact: 'Contact',
    d_contacts: 'Contacts',
    d_client: 'client',
    d_lead: 'lead',
    d_leads: 'Leads',
    d_matter: 'Case',
    d_case: 'case',
    d_cases: 'Cases',
    d_report: 'report',

    // Common button labels
    d_add: 'add',
    d_edit: 'edit',
    d_delete: 'delete',
    d_remove: 'remove',
    d_actions: 'actions',
    d_restore: 'restore',

    // Other labels
    d_expense: 'expense',
    d_expenses: 'expenses',
    d_labor: 'labor',
    d_clients: 'clients',
    d_notes: 'notes',
    d_invoice: 'invoice',
    d_balance: 'balance',
    d_minimum: 'minimum',
    d_needed: 'needed',
    d_due: 'due',
    d_initialConsult: 'initial consult',
    d_trustFor: (params: {value: string}) => `Trust for ${params.value}`,

    // Errors
    d_error: 'Error: ',
    d_na: 'N/A',

    // Warnings
    d_changesMade: 'Changes made, are you sure?',
    d_changesMadeDescription: 'Changes have been made, are you sure you want to lose the changes?',
    d_merge: 'Merge',
    d_noSafeDelete: 'and can not be deleted safely*',
    d_safeDelete: 'but can be deleted safely',
    d_otherUses: (params: {entity: string}) => `This ${params.entity} is used in other places`,

    // Tables
    d_total: 'Total',

    // General
    d_date: 'date',
    d_today: 'today',
    d_view: 'view',
    d_type: 'type',
    d_unknown: 'unknown',
    d_nothing: 'nothing'
};